import { TableCell } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)`
  background-color: var(--background-soft);
`;
